<template>
  <div class="borrowerAttributeEmail">
    <BorrowerAttributeConstructor
      :questionText="questionText"
      :description="description"
      :descriptionTooltip="descriptionTooltip"
      :disclaimer="disclaimer">
      <template v-slot:input>
        <div class="form-floating ba-text mb-5">
          <input
            :id="'ba' + question.id"
            :name="'ba' + question.id"
            class="form-control"
            inputmode="text"
            :class="{'is-invalid': v$.value && v$.value.$invalid && v$.value.$dirty}"
            :disabled="disabled || question.group === 'bankValues'"
            :maxlength="question.maxLength"
            :minlength="question.minLength"
            :placeholder="question.placeholder || label"
            :aria-label="label"
            :required="question.required"
            v-model="value"
            @blur="onBlur(v$.value, $event)"
            @keyup="!singleForm && onChange(v$.value, $event, false)"
            @keydown.enter="onChange(v$.value, $event, true)"
            :data-cy="question.alias"
            :dreams-id="question.alias"
          />
          <label :for="'ba' + question.id">
            <span>{{ label }}</span>
          </label>
          <LendioBootstrapTooltip v-if="tooltipText">
            <span class="text-tooltip-icon" data-bs-toggle="tooltip" data-bs-placement="right" :title="tooltipText">
              <i class="fa-light fa-circle-info"></i>
            </span>
          </LendioBootstrapTooltip>
          <small class="invalid-feedback" v-if="v$ && v$.value && v$.value.$error">
            <i class="fa-light fa-circle-exclamation"></i> {{ errorText }}
          </small>
        </div>
      </template>
    </BorrowerAttributeConstructor>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { mapState } from 'pinia'
import { required, email } from '@vuelidate/validators'
import get from 'lodash/get'
import BaseBorrowerAttributeMixin from "./BaseBorrowerAttributeMixin";
import { useQuestionsStore } from '~/store/questions'

export default {
  props: {
    question: Object,
    alias: String,
    disabled: Boolean,
    updateStoreValue: Function,
    borrowerInterest: String
  },
  emits: ['invalidity','answer'],
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      errorMessage: 'This field is invalid'
    }
  },
  computed: {
    ...mapState(useQuestionsStore, ['singleForm']),
    invalid() {
      return get(this.v$, 'value.$invalid')
    },
    errorText() {
      return get(this.v$, 'value.$error') ? this.errorMessage : ''
    }
  },
  created () {
    this.$watch('invalid', (invalid) => {
      this.$emit('invalidity', invalid)
    }, {immediate: true})

    this.errorMessage = 'Please enter an Email'
  },
  mixins: [BaseBorrowerAttributeMixin],
  validations: function () {
      return {
        value: { required: required, email: email}
      }
  },
  methods: {
    onBlur(v$, e) {
      v$.$touch()
      let postValue = e.target.value
      if (this.singleForm) {
        this.$emit('answer', { value: parseInt(postValue, 10), isInvalid: v$.$error, submitImmediately: false })
      }

      if (typeof postValue !== 'string' || !postValue.indexOf('%')) {
        this.value = this.value === postValue ? postValue + '%' : this.value
      }

    },
    onChange (v$, e, submitImmediately) {
      if (!v$.invalid) {
        v$.$touch()
      }
      let postValue = e.target.value
      this.$emit('answer', { value: postValue, isInvalid: v$.$error, submitImmediately })
    }
  }
}
</script>

<style scoped lang="scss">
.ba-text {
  label {
    color: $type-400;
    @include media-breakpoint-down(lg) {
      font-size: 14px;
    }
  }
}
.text-tooltip-icon {
  position: absolute;
  top: 0.9rem;
  right: 1rem;
  color: $blue-300;
}
</style>
